// Loading
export const SHOW_LOADING = 'SHOW_LOADING'
export const HIDE_LOADING = 'HIDE_LOADING'

// Profile
export const INIT_STATE = 'INIT_STATE'
export const SET_PROFILE = 'SET_PROFILE'

